<template>
	<div :class="message.highLight ? 'infoitem' : ''">
		<div>
			<svg-icon :icon-class="getIconName(message.status)" style="font-size: 20px; margin-right: 8px;"/>
			<span class="info-title">{{message.title}}</span>
			<span class="info-desc">{{message.sendtime}}</span>
		</div>
		<div style="margin-left: 28px;">
			<span class="info-sec" v-html="message.content"></span>
		</div>
	</div>
</template>
<script>
export default {
	name: "infoItem",
	props: {
		message: {
			type: Object
		}
	},
	data() {
		return {

		}
	},
	methods: {
		getIconName(status) {
			switch (status) {
				case "success":
					return "message_success";
				case "warn":
					return "message_warn";
				case "fail":
					return "message_fail";
				default:
				return "";
			}
		},
	}
}
</script>
<style lang='scss' scoped>
.info-title{
  display: inline-block;
  margin-right: 8px;
  font-size: 16px;
  color: #3C4353;
  vertical-align: middle;
  font-weight: 600;
  line-height: 40px;
}

.info-desc{
  display: inline-block;
  font-size: 12px;
  color: #838A9D;
  vertical-align: middle;
}

.info-sec{
  display: inline-block;
  font-size: 14px;
  color: #838A9D;
  vertical-align: middle;
  line-height: 20px;
}
.infoitem {
	background: rgba(245, 108, 108, 0.5);
	padding: 5px;
}
</style>